const AFTERNOON_TENANTS = ['afternoon', 'kim_jenkins', 'dusk_wealth', 'monument'];
const AFTERNOON_EMAIL_DOMAIN = '@afternoon.co.uk';

export function hasAfternoonAccess(
  tenantId: string | undefined,
  emailAddress: string | undefined,
): boolean {
  if (!tenantId || !emailAddress) return false;
  return (
    AFTERNOON_TENANTS.includes(tenantId) &&
    emailAddress.toLowerCase().endsWith(AFTERNOON_EMAIL_DOMAIN)
  );
}
